{
  "dismiss": "Schließen"
}